export const queryKeys = {
  trialBalanceAvailability: (clientId: string) =>
    ['compliance', 'trial-balance-availability', clientId] as const,
  jobs: (clientId: string, skip: number, take: number, orgId: string) =>
    ['compliance', 'jobs', clientId, skip, take, orgId] as const,
  jobStatus: (clientId: string, jobId: string) =>
    ['compliance', 'job-status', clientId, jobId] as const,
  xeroTrialBalance: (clientId: string, jobId: string) =>
    ['compliance', 'xero-trial-balance', clientId, jobId] as const,
  complianceAssets: (clientId: string, jobId: string) =>
    ['compliance', 'assets', clientId, jobId] as const,
  complianceLogs: (clientId: string, jobId: string) =>
    ['compliance', 'logs', clientId, jobId] as const,
}
